import { registerFlow } from '../../../../core/flow-register';
import { makeFlow } from '../index';
import { IRAAccountTypes } from '../../../transfer-flows/loaders';

registerFlow(
  makeFlow('rollover-ira', {
    toIRAAccountType: IRAAccountTypes.ROLLOVER,
    fromIRAAccountType: IRAAccountTypes.ROLLOVER
  })
);
